export default __webpack_public_path__ + "static/tanulo_1-865d6d6d965e495748ce4660dd61c9ea.webp";